import { useUserStore } from '@/store/User';

export default () => {
  const status = ref('Active');
  const timeoutId: any = ref();
  const refreshTimeoutId: any = ref();
  const userStore = useUserStore();

  const resetInactivityTimer = () => {
    clearTimeout(timeoutId.value);
    timeoutId.value = setTimeout(() => {
      status.value = 'Inactive';
      if (userStore.userinfo.countryCode !== 'KR') {
        refreshPage();
      }
    }, 30 * 1000); // 30秒
  };

  const listenForActivity = () => {
    document.addEventListener('mouseover', resetInactivityTimer);
    document.addEventListener('mousedown', resetInactivityTimer);
    document.addEventListener('keydown', resetInactivityTimer);
    document.addEventListener('touchstart', resetInactivityTimer);
    document.addEventListener('scroll', resetInactivityTimer);
    document.addEventListener('wheel', resetInactivityTimer);
  };

  const startRefreshTimer = () => {
    const now = new Date();
    const nextRefreshTime = new Date(now.getTime() + 8 * 60 * 60 * 1000); // 8小时后
    const timeToNextRefresh = nextRefreshTime.getTime() - now.getTime();

    refreshTimeoutId.value = setTimeout(() => {
      status.value = 'Checking inactivity...';
      listenForActivity();
      resetInactivityTimer();
    }, timeToNextRefresh);
  };

  const refreshPage = () => {
    if (!import.meta.env.SSR) {
      window.location.reload();
    }
  };

  const init = () => {
    if (userStore.userinfo.countryCode !== 'KR') {
      startRefreshTimer();
    }
  };

  const cleanup = () => {
    clearTimeout(timeoutId.value);
    clearTimeout(refreshTimeoutId.value);
    document.removeEventListener('mousemove', resetInactivityTimer);
    document.removeEventListener('mousedown', resetInactivityTimer);
    document.removeEventListener('keydown', resetInactivityTimer);
    document.removeEventListener('touchstart', resetInactivityTimer);
    document.removeEventListener('scroll', resetInactivityTimer);
    document.removeEventListener('wheel', resetInactivityTimer);
  };

  return {
    status,
    init,
    cleanup
  };
};
